import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';

function toggleDropdown([dropdown, handler]) {
  assert(
    `Expected '${dropdown}' to be a Ember Basic Dropdown object. (toggle-dropdown dd)`,
    typeof dropdown?.actions?.toggle === 'function',
  );
  assert(
    `Expected '${handler}' to be a function, if present.`,
    !handler || typeof handler === 'function',
  );

  return function (...args) {
    dropdown.actions.toggle();
    if (handler) handler(...args);
  };
}

export default helper(toggleDropdown);
